import React, { useContext, useState } from 'react';
import './Questions.scss';
import { layoutContext } from '../DORAAssessment';
import {
  CheckmarkOutline24,
  MisuseOutline24,
  Pending24,
} from '@carbon/icons-react';

interface singleOptionProps {
  options: any[];
}

const SingleOption = (sOMProps: singleOptionProps) => {
  const { options } = sOMProps;
  const { setSelectedOption } = useContext(layoutContext);

  const [selectedRadio, setSelectedRadio] = useState(-1);

  const handleOptionChange = (item: any, index: number) => {
    setSelectedRadio(index);
    setSelectedOption(item);
  };

  const renderIcon = (i: number) => {
    switch (i) {
      case 0:
        return <CheckmarkOutline24 />;
      case 1:
        return <MisuseOutline24 />;
      case 2:
        return <Pending24 />;
    }
  };

  return (
    <div className="dora-assessment__single-option-container">
      {options.map((option: any, i: number) => (
        <div
          key={option.id}
          className={`bx--col dora-assessment__single-option ${
            selectedRadio === i ? 'dora-assessment__single-option-selected' : ''
          }`}
          onClick={() => handleOptionChange(option, i)}
        >
          <div
            className={`${
              selectedRadio === i
                ? 'dora-assessment__single-option-card_selected'
                : 'dora-assessment__single-option-card'
            }`}
          >
            {renderIcon(i)}
            <input
              type="radio"
              name="options"
              checked={selectedRadio === i}
              onChange={() => handleOptionChange(option, i)}
              className="dora-assessment__single-option-input"
            />
            <div className="dora-assessment__single-option-text">
              {option.text}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SingleOption;
